import { render, staticRenderFns } from "./gptSaved.vue?vue&type=template&id=c7d3507a&scoped=true&"
import script from "./gptSaved.vue?vue&type=script&lang=js&"
export * from "./gptSaved.vue?vue&type=script&lang=js&"
import style0 from "./gptSaved.vue?vue&type=style&index=0&id=c7d3507a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d3507a",
  null
  
)

export default component.exports